module.exports = __webpack_public_path__ + "img/g3.fcb87948.png";